module.exports = __webpack_public_path__ + "img/up-button.22eb9540.png";